<template>
  <v-card>
    <v-card-text>
      <p class="display-1">{{student.user.username}}</p>
      <p>Klasse: {{student.class_number}}{{student.class_variant}}</p>
    </v-card-text>
    <v-dialog v-model="showDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Passwort ändern</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <ChangePassword />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showMessages"
      v-for="(message, index) in messages"
      v-bind="message"
      :key="index"
    >{{message.message}}</v-snackbar>
    <v-card-actions>
      <v-btn text @click="logout">Abmelden</v-btn>
      <v-btn text color="primary" dark @click="showDialog = true">Passwort ändern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import user from "@/services/user.js";
import ChangePassword from "@/components/ChangePassword";
export default {
  components: { ChangePassword },
  data() {
    return {
      student: { user: {} },
      messages: [],
      showMessages: false,
      showDialog: false
    };
  },
  created() {
    user.fetchUser().then(it => (this.student = it.data[0]));
  },
  methods: {
    logout() {
      user.logout();
      this.$router.push({ name: "Home" });
      location.reload();
    }
  }
};
</script>

<style>
</style>
